import { Box } from '@quintoandar-tokko/jopijs';
import Skeletons from '@/components/Skeletons/Skeletons';

export default function PageSkeleton() {
  return (
    <Box style={{ display: 'flex', flexDirection: 'column', gap: '24px' }}>
      <Skeletons height="56px" style={{ borderRadius: '0 0 16px 16px' }} />

      <Box
        style={{
          display: 'flex',
          gap: '40px',
        }}
      >
        <Skeletons
          width="220px"
          height="calc(100vh - 80px)"
          style={{ borderRadius: '16px' }}
        />

        <Skeletons
          width="calc(100vw - 536px)"
          height="calc(100vh - 80px)"
          style={{ borderRadius: '16px' }}
        />

        <Box
          style={{
            display: 'flex',
            flexDirection: 'column',
            gap: '16px',
            marginRight: '32px',
          }}
        >
          <Skeletons
            width="234px"
            height="203px"
            style={{ borderRadius: '12px' }}
          />

          <Skeletons
            width="234px"
            height="203px"
            style={{ borderRadius: '12px' }}
          />

          <Skeletons
            width="234px"
            height="calc(100vh - 526px)"
            style={{ borderRadius: '12px', maxHeight: '280px' }}
          />
        </Box>
      </Box>
    </Box>
  );
}
